if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();

        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
      }

      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);

        const initialIndex = Math.max(
          this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'),
          0
        );

        this.activateTab(initialIndex, { moveFocus: false });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
      }

      handleClick(event) {
        const tab = event.target.closest('[role="tab"]');

        if (!tab || !this.contains(tab)) return;

        const index = this.tabs.indexOf(tab);

        if (index === -1) return;

        this.activateTab(index, { moveFocus: false });
      }

      handleKeydown(event) {
        const currentTab = event.target.closest('[role="tab"]');

        if (!currentTab) return;

        const currentIndex = this.tabs.indexOf(currentTab);
        let nextIndex = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            nextIndex = (currentIndex + 1) % this.tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = this.tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.activateTab(nextIndex, { moveFocus: true });
      }

      activateTab(index, { moveFocus }) {
        this.style.setProperty('--product-tabs-active-index', index);

        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');

          if (isActive && moveFocus) {
            tab.focus();
          }
        });

        this.panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === index;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', false);

          if (isActive) {
            requestAnimationFrame(() => panel.classList.toggle('is-active', true));
          }
        });
      }
    }
  );
}